import initializeCategories from './woo/categories';
import initializePersonalData from './woo/personal-data';
import initializeSingleProduct from './woo/single-product';
export default class WooCommerce {
    constructor() {
        this.initialize();
    }

    initialize() {
        initializeCategories();
        initializePersonalData();
        initializeSingleProduct();
    }
}